export default __webpack_public_path__ + "static/media/404.baed1e3b.svg";